export const DefaultConfigurationContactTemplate = JSON.parse(`
{
    "width":"632",
    "sectionList":[
        {
             "name": "BASIC INFORMATION",
             "sectionId": "sec1"
        },
        {
            "name": "CONTACT INFORMATION",
            "sectionId": "sec2"
        },
        {
             "name": "ADDRESS",
             "sectionId": "sec3"
        },
        {
            "name": "EMPLOYMENT",
            "sectionId": "sec4"
        },
        {
            "name": "RELATIONSHIPS",
            "sectionId": "sec5"
        },
        {
            "name": "INTERNET INFORMATION",
            "sectionId": "sec6"
        },
        {
            "name": "OTHER",
            "sectionId": "sec7"
        },
        {
            "name": "NOTES",
            "sectionId": "sec8"
        }
    ],
    "contains": [
        {
            "sectionName": "BASIC INFORMATION",
            "secSName":"Basic Information",
            "isExpandSection": true,
            "sectionId": "sec1",
            "container": [
                [
                    {
                        "config": {
                            "controlName": "First Name",
                            "controlType": "input",
                            "controlID": "FirstName",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isRequired": true,
                            "isDisabled":false,
                            "maxLength":"63"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "304",
                            "height": "32"
                        }
                    },
                    {
                        "config": {
                            "controlName": "Last Name",
                            "controlType": "input",
                            "controlID": "LastName",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isRequired": false,
                            "isDisabled":false,
                            "maxLength":"63"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "304",
                            "height": "32"
                        }
                    }
                ],
                [
                    {
                        "config": {
                            "controlName": "Alias",
                            "controlType": "alias",
                            "controlID": "Alias",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isRequired": false,
                            "isDisabled":false,
                            "placeHolder": "User 'Enter' to input multiple values"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "30"
                        }
                    }
                ],
                [
                    {
                        "config": {
                            "controlName": "Company",
                            "controlType": "dropdown",
                            "controlID": "Company",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isRequired": false,
                            "isDisabled":false,
                            "defaultValue":"relationship",
                            "source":"all"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "30"
                        }
                    }
                ],
                [
                    {
                        "config": {
                            "controlName": "Job Title",
                            "controlType": "med-input",
                            "controlID": "JobTitle",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isRequired": false,
                            "isDisabled":false,
                            "isAllowFly":false
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "30"
                        }
                    }
                ],
                [
                    {
                        "config": {
                            "controlName": "Job Function",
                            "controlType": "job-function",
                            "controlID": "JobFunction",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isRequired": false,
                            "isDisabled":false
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "30"
                        }
                    }
                ]
            ]
        },
        {
            "sectionName": "CONTACT INFORMATION",
            "secSName":"Contact Information",
            "isExpandSection": false,
            "sectionId": "sec2",
            "container": [
                [
                    {
                        "config": {
                            "controlName": "Phone",
                            "controlType": "combine-dropdown-input",
                            "controlID": "Phone",
                            "type":"Phone",
                            "isLabelHidden": false,
                            "isHidden": false,
                            "isRequired": false,
                            "isDisabled": false,
                            "isSupportDynamic":true,
                            "addlabel":"+Add Phone Number",
                            "defaultValue":"Work"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "30",
                            "leftWidth":"152",
                            "rightWidth":"456"
                        },
                        "dataSource": [
                            {"name":"Work","fix":true},
                            {"name":"Mobile","fix":true},
                            {"name":"Home","fix":true},
                            {"name":"Fax","fix":true}
                        ]
                    }
                ],
                [
                    {
                        "config": {
                            "controlName": "Emails",
                            "controlType": "combine-dropdown-input",
                            "controlID": "Emails",
                            "type":"Emails",
                            "isLabelHidden": false,
                            "isHidden": false,
                            "isRequired": false,
                            "isDisabled": false,
                            "isSupportDynamic":true,
                            "addlabel":"+Add Email",
                            "defaultValue":"Work",
                            "isPrimary":true
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "30",
                            "leftWidth":"152",
                            "rightWidth":"456"
                        },
                        "dataSource": [
                            {"name":"Work","fix":true},
                            {"name":"Personal","fix":true},
                            {"name":"Assistant","fix":true},
                            {"name":"Other","fix":true}
                        ]
                    }
                ]
            ]
        },
        {
            "sectionName": "ADDRESS",
            "secSName":"Address",
            "isExpandSection": false,
            "sectionId": "sec3",
            "container": [
                [
                    {
                        "config": {
                            "controlName": "Address",
                            "controlType": "combine-address",
                            "controlID": "Address",
                            "type":"Address",
                            "isLabelHidden": true,
                            "isHidden": false,
                            "isRequired": false,
                            "isDisabled": false,
                            "isSupportDynamic":true,
                            "addlabel":"+Add Address",
                            "defaultValue":"Work",
                            "defaultValueCountry":"United States"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "112",
                            "height": "30",
                            "leftWidth":"152",
                            "rightWidth":"456"
                        },
                        "dataSource": [
                            {"name":"Work","fix":true},
                            {"name":"Home","fix":true}
                        ]
                    }
                ]
            ]
        },
        {
            "sectionName": "EMPLOYMENT",
            "secSName":"Empoloyment",
            "isExpandSection": false,
            "sectionId": "sec4",
            "container": [
                [
                    {
                        "config": {
                            "controlName": "Company: ",
                            "controlType": "label",
                            "controlID": "EmploymentCompany",
                            "isLabelHidden": true,
                            "isHidden":false,
                            "isDisabled":false
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "100",
                            "height": "32"
                        }
                    }
                ],
                [
                    {
                        "config": {
                            "controlName": "",
                            "controlType": "Combine-CurrentEmployment",
                            "controlID": "CurrentEmploment",
                            "type":"CurrentEmploment",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isDisabled":true,
                            "defaultValue":"relationship"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "304",
                            "leftWidth":"304",
                            "rightWidth":"304",
                            "height": "30"
                        }
                    }
                ],
               [
                    {
                        "config": {
                            "controlName": "Former Employments",
                            "controlType": "divider",
                            "controlID": "FormerEmploymentsDivider",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isAllowFly":true
                        },
                        "css": {
                            "labelSize": "14",
                             "width": "616",
                            "height": "30"
                        }
                    }
                ],
                [
                    {
                        "config": {
                            "controlName": "",
                            "controlType": "Former-Employment",
                            "controlID": "FormerEmployment",
                            "type":"FormerEmployment",
                            "isLabelHidden": false,
                            "isHidden": true,
                            "isDisabled": false,
                            "isSupportDynamic":true,
                            "addlabel":"+Add former position",
                            "defaultValue":"",
                            "source":"all"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "30",
                            "leftWidth":"304",
                            "rightWidth":"304",
                            "rightWidthYear":"148"
                        }
                    }
                ]
            ]
        },
        {
            "sectionName": "RELATIONSHIPS",
            "secSName":"Relationships",
            "isExpandSection": false,
            "sectionId": "sec5",
            "container": [
                [
                    {
                        "config": {
                            "controlName": "Add more relationships for current contact:",
                            "controlType": "Combine-Relationships",
                            "controlID": "Relationships",
                            "type":"Relationships",
                            "isLabelHidden": false,
                            "isHidden": false,
                            "isDisabled": false,
                            "isSupportDynamic":true,
                            "defaultValue":"relationship",
                            "addlabel":"+Add Relationships"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "30",
                            "leftWidth":"152",
                            "rightWidth":"456"
                        },
                        "dataSource":[]
                    }
                ]
            ]
        },
        {
            "sectionName": "INTERNET INFORMATION",
            "secSName":"Internet",
            "isExpandSection": false,
            "sectionId": "sec6",
            "container": [
                [
                    {
                        "config": {
                            "controlName": "",
                            "controlType": "combine-dropdown-input",
                            "controlID": "Internet",
                            "type":"Internet",
                            "isLabelHidden": false,
                            "isHidden": false,
                            "isDisabled": false,
                            "isSupportDynamic":true,
                            "addlabel":"+Add More",
                            "defaultValue":"LinkedIn"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "614",
                            "height": "30",
                            "leftWidth":"152",
                            "rightWidth":"456"
                        },
                        "dataSource": [
                            {"name":"LinkedIn","fix":true},
                            {"name":"Facebook","fix":true},
                            {"name":"IM","fix":true},
                            {"name":"Twitter","fix":true}
                        ]
                    }
                ]
            ]
        },
        {
            "sectionName": "OTHER",
            "secSName":"Other",
            "isExpandSection": false,
            "sectionId": "sec7",
            "container": [
                [
                    {
                        "config": {
                            "controlName": "Birthday",
                            "controlType": "date",
                            "controlID": "Birthday",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isRequired": false,
                            "isDisabled":false,
                            "isRemoved":true
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "30"
                        }
                    }
                ]
            ]
        },
        {
            "sectionName": "NOTES",
            "secSName":"Notes",
            "isExpandSection": false,
            "sectionId": "sec8",
            "container": [
                [
                    {
                        "config": {
                            "controlName": "",
                            "controlType": "textarea",
                            "controlID": "Notes",
                            "isLabelHidden": false,
                            "isHidden":false,
                            "isDisabled":false,
                            "maxLength":"2048"
                        },
                        "css": {
                            "labelSize": "14",
                            "width": "616",
                            "height": "280"
                        }
                    }
                ]
            ]
        }
    ]
}
`);
